<template>
	<div class="container__dashboard">
		<ContentHeader>
			<SubHeader
				:title="tituloDashboard"
				:subtitle="labelUltimoProcessamento"
			>
				<template #actions>
					<!-- <Button
            :label="$t('download')"
            color="trv-neutral"
            semanticClass="mini"
            widthAuto
          /> -->
					<ButtonDropdown
						v-model="fazendaId"
						:label="$t('selectFarm')"
						color="trv-default"
						min-width="11rem"
						semantic-class="mini"
						:options="fazendas"
					/>
				</template>
				<template #main>
					<div
						v-show="exibirKpis"
						class="container__dashboard__kpis"
					>
						<KPI
							v-for="(kpi, index) in kpis || 6"
							:key="index"
							:value="kpi.value"
							:description="kpi.label"
						/>
					</div>
				</template>
			</SubHeader>
		</ContentHeader>
		<ContentBody>
			<Card>
				<CardMap
					ref="ref__cardmap"
					:is-dashboard-geral="isDashboardGeral"
					:set-fazenda-id="setFazendaId"
				>
					<div v-show="$store.state.moduleDashboardCardInfo.plantiosFazenda.features">
						<ProductivityBar
							:min="minByVariavelBiometrica"
							:max="maxByVariavelBiometrica"
						/>
						<SimpleDropdown
							v-model="$store.state.moduleDashboardCardInfo.variavelBiometricaMapa"
							:options="dropdownVariaveisBiometricas"
							class="w-fit float-right m-4"
						/>
					</div>
				</CardMap>
			</Card>
			<Card
				v-show="exibirGraficoMaterialGenetico && exibirGraficoFaixaDeIdade"
				class="container__dashboard__contentbody__card"
			>
				<GraficoMaterialGenetico
					:data="dataGraficoMaterialGenetico"
					:data-do-ultimo-processamento="labelUltimoProcessamento"
				/>
				<hr />
				<GraficoFaixaDeIdade
					:data="dataGraficoFaixaDeIdade"
					:data-do-ultimo-processamento="labelUltimoProcessamento"
				/>
			</Card>
			<Card
				v-if="!isDashboardGeral"
				v-show="exibirGraficoCategoriaDeArvores"
				class="container__dashboard__contentbody__card"
			>
				<GraficoCategoriaDeArvore
					:data="dataGraficoFazendaCategoriaDeArvores"
					:subtitle="labelUltimoProcessamento"
				/>
				<hr />
				<GraficoArvoresUteis
					v-show="exibirGraficoArvoresUteis"
					:data="dataGraficoArvoresUteis"
					:subtitle="labelUltimoProcessamento"
				/>
			</Card>
			<Card
				v-if="isDashboardGeral"
				v-show="exibirGraficoFazendas"
				class="container__dashboard__contentbody__card"
			>
				<GraficoFazenda
					:data="dataGraficoFazendas"
					:data-do-ultimo-processamento="labelUltimoProcessamento"
				/>
			</Card>
			<Card
				v-if="!isDashboardGeral"
				v-show="exibirGraficoArvoresUteisPorPlantio"
				class="container__dashboard__contentbody__card"
				style="flex-direction: column"
			>
				<GraficoArvoresUteisPorPlantio
					:data="dataGraficoArvoresUteisPorPlantio"
					:subtitle="labelUltimoProcessamento"
				/>
			</Card>

			<Card
				v-if="!isDashboardGeral"
				v-show="dadosNivelPovoamentoEstrato.length"
				class="container__dashboard__contentbody__card p-4 flex !flex-col max-h-[33%] gap-16"
			>
				<div class="flex items-center gap-4 justify-between">
					<ul class="flex gap-6">
						<li
							class="font-bold text-lg cursor-pointer"
							:class="nivel === 'resumo' ? 'text-[#01395E]' : 'text-[#B0B6C2]'"
							@click="nivel = 'resumo'"
						>
							{{ $t('summary') }}
						</li>

						<li
							class="font-bold text-lg cursor-pointer"
							:class="nivel === 'estrato' ? 'text-[#01395E]' : 'text-[#B0B6C2]'"
							@click="nivel = 'estrato'"
						>
							{{ $t('stratum') }}
						</li>
						<li
							class="font-bold text-lg cursor-pointer"
							:class="nivel === 'talhao' ? 'text-[#01395E]' : 'text-[#B0B6C2]'"
							@click="nivel = 'talhao'"
						>
							{{ $t('section') }}
						</li>
						<!-- <li @click="nivel = 'arvore'" class="font-bold text-lg cursor-pointer" :class="nivel === 'arvore' ? 'text-[#01395E]' : 'text-[#B0B6C2]'">Árvore</li> -->
						<li
							class="font-bold text-lg cursor-pointer"
							:class="nivel === 'sortimento' ? 'text-[#01395E]' : 'text-[#B0B6C2]'"
							@click="nivel = 'sortimento'"
						>
							{{ $t('assortment') }}
						</li>
						<!-- <li @click="nivel = 'clima'" class="font-bold text-lg cursor-pointer"
            :class="nivel === 'clima' ? 'text-[#01395E]' : 'text-[#B0B6C2]'">Clima</li> -->
					</ul>
					<div>
						<Button
							:label="$t('exportCsv')"
							color="trv-default"
							semantic-class="tiny"
							width-auto
							@click="ExportarCsv"
						/>
					</div>
					<div class="gap-2 flex flex-col">
						<div
							v-if="nivel === 'resumo'"
							class="flex gap-2"
						>
							<SimpleDropdown
								v-model="estratoNivelPovoamentoEscolhidoOrDefault"
								:options="
									estratosDaFazenda.map((m) => {
										return { key: m.idEstratoFlorestal, label: m.descricao }
									})
								"
							/>
							<SimpleDropdown
								v-model="processamentoNivelPovoamentoEscolhidoOrDefault"
								:options="
									processamentosDoEstratoEscolhido.map((m) => {
										return { key: m.idInventarioFlorestal, label: m.descricao }
									})
								"
							/>
						</div>
						<div
							v-if="nivel != 'sortimento'"
							class="flex flex-col relative"
						>
							<SimpleDropdown
								v-model="variavelSelecionada"
								:options="dropdownVariaveisBiometricas"
							/>
						</div>
						<div
							v-else-if="dropdownProcessamentoSortimento.length"
							class="flex gap-4"
						>
							<SimpleDropdown
								v-model="quantidadeVolume"
								:options="quantidadeVolumeOptions"
							/>
							<SimpleDropdown
								v-model="inventarioFlorestalIdEscolhido"
								:options="
									dropdownProcessamentoSortimento.map((m) => {
										return { key: m.inventarioFlorestalId, label: m.descricao }
									})
								"
							/>
						</div>
					</div>
				</div>

				<div
					v-if="nivel === 'estrato'"
					class="w-full"
				>
					<div
						v-if="nivelPovoamentoEstrato.length"
						class="flex gap-4 h-fit"
					>
						<GraficoNivelPovoamentoEstrato
							:title-y="
								dropdownVariaveisBiometricas.find(
									(variavel) => variavel.key === variavelSelecionada,
								).label || ''
							"
							:data="dadosNivelPovoamentoEstrato"
						/>
						<CustomLegend
							v-model="estratosEscolhidos"
							class="min-w-[20%]"
							:data="nivelPovoamentoEstrato"
						/>
					</div>
					<Loading v-else />
				</div>
				<div
					v-if="nivel === 'talhao'"
					class="w-full"
				>
					<div
						v-if="nivelPovoamentoTalhao.length"
						class="flex gap-4 h-fit"
					>
						<GraficoNivelPovoamentoEstrato
							:data="dadosNivelPovoamentoTalhao"
							:title-y="
								dropdownVariaveisBiometricas.find(
									(variavel) => variavel.key === variavelSelecionada,
								).label || ''
							"
						/>
						<CustomLegend
							v-model="talhoesEscolhidos"
							class="min-w-[20%]"
							:data="nivelPovoamentoTalhao"
						/>
					</div>
					<Loading v-else />
				</div>

				<div
					v-if="nivel === 'sortimento'"
					class="w-full"
				>
					<GraficoSortimento
						v-if="dadosSortimento.length"
						:title-y="quantidadeVolumeOptions.find((f) => f.key === quantidadeVolume).label"
						:categorias="categorias"
						:data="sortimento"
					/>
					<p v-else>
						{{ $t('thereIsNoAssortment') }}
					</p>
					<!-- <Loading v-else /> -->
					<!-- <GraficoNivelPovoamentoEstrato :data="dadosNivelPovoamentoTalhao" /> -->
				</div>
				<div
					v-if="nivel === 'arvore'"
					class="w-full"
				>
					<div
						v-if="nivelPovoamentoArvore.length"
						class="flex gap-4 h-fit"
					>
						<GraficoNivelPovoamentoEstrato
							:data="dadosNivelPovoamentoArvore"
							:title-y="
								dropdownVariaveisBiometricas.find(
									(variavel) => variavel.key === variavelSelecionada,
								).label || ''
							"
						/>
						<CustomLegend
							v-model="arvoresEscolhidas"
							class="min-w-[20%]"
							:data="nivelPovoamentoArvore"
						/>
					</div>
					<Loading v-else />
				</div>

				<div
					v-if="nivel === 'resumo'"
					class="flex flex-col gap-6"
				>
					<CrudTable
						:show-sort-options="false"
						:headers="tableHeaders"
						:data="variavelSelecionada ? variavelNivelPovoamento : nivelPovoamento"
						:table-configuration="tableConfiguration"
					/>
					<CrudTable
						v-show="Object.keys(relacaoVariavel).includes(variavelSelecionada)"
						:show-sort-options="false"
						:headers="tableHeaders"
						:data="variavelRelacionadaNivelPovoamento"
						:table-configuration="tableConfiguration"
					/>
				</div>
			</Card>
		</ContentBody>
	</div>
</template>

<script>
// import Button from "../../components/Button/Button";
import { groupBy, orderBy } from 'lodash'
import ButtonDropdown from '../../components/ButtonDropdown/ButtonDropdown'
import Button from '../../components/Button/Button'
import Card from '../../components/Card/Card'
import ContentBody from '../../components/ContentBody/ContentBody'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import CrudTable from '../../components/CrudTable/CrudTable'
import CustomLegend from '../../components/CustomLegend/CustomLegend'
import KPI from '../../components/KPI/KPI'
import Loading from '../../components/Loading/Loading'
import ProductivityBar from '../../components/ProductivityBar/ProductivityBar.vue'
import SimpleDropdown from '../../components/SimpleDropdown/SimpleDropdown'
import SubHeader from '../../components/SubHeader/SubHeader'
import { variaveisBiometricas } from '../../constants/Mappings/VariaveisBiometricasDashboard.js'
import GraficoArvoresUteis from './CardGrafico/Graficos/GraficoArvoresUteis'
import GraficoArvoresUteisPorPlantio from './CardGrafico/Graficos/GraficoArvoresUteisPorPlantio'
import GraficoCategoriaDeArvore from './CardGrafico/Graficos/GraficoCategoriaDeArvore'
import GraficoFaixaDeIdade from './CardGrafico/Graficos/GraficoFaixaDeIdade'
import GraficoFazenda from './CardGrafico/Graficos/GraficoFazenda/GraficoFazenda'
import GraficoMaterialGenetico from './CardGrafico/Graficos/GraficoMaterialGenetico'
import GraficoNivelPovoamentoEstrato from './CardGrafico/Graficos/GraficoNivelPovoamentoEstrato'
import GraficoSortimento from './CardGrafico/Graficos/GraficoSortimento'
import CardMap from './CardMap/CardMap'

import axios from 'axios'
import chroma from 'chroma-js'

import {
	getAllInventarioPlantioByFaixaDeIdade,
	getAllInventarioPlantioByMaterialGenetico,
	getDashboardDataByInventarioIdList,
	getDataUltimoProcessamento,
	getDataUltimoProcessamentoByFazendaId,
	getDropdownProcessamentoSortimento,
	getEstratosByFazendaId,
	getHistoricoNivelPovoamentoEstrato,
	getHistoricoNivelPovoamentoTalhao,
	getInventarioFlorestalComInventarioPlantio,
	getInventarioPlantioGroupedByFaixaDeIdadeEqualsFazendaId,
	getInventarioPlantioGroupedByMaterialGeneticoEqualsFazendaId,
	getKpiDashboardFazenda,
	getKpiDashboardGeral,
	getNivelPovoamentoByInventarioFlorestalId,
	getProcessamentosByEstratoId,
	getProporcaoDeArvoresUteisByFazendaId,
	getProporcaoDeArvoresUteisGroupedByPlantioEqualsFazendaId,
	getQuantidadeDeArvoresPorCategoriaByFazendaId,
	getSortimentoByInventarioFlorestalId,
} from '../../services/requests/DashBoardRequests'
import { getAllFazendasComInventarioFlorestalDropdown } from '../../services/requests/FazendaRequests'

import {
	converterUnidadeParaLiteral,
	converterAreaParaLiteral,
	converterVolumeParaLiteral,
	converterIMAParaLiteral,
} from '../../utils/helpers'
import { CoordenatesToGooglePattern } from '../../utils/MapFunctions'

import { mapGetters } from 'vuex'

export default {
	name: 'Dashboard',

	computed: {
		...mapGetters('moduleDashboardCardInfo', [
			'cardInfoWithInfoGeo',
			'inventariosIdSelecionados',
			'minByVariavelBiometrica',
			'maxByVariavelBiometrica',
		]),

		estratoNivelPovoamentoEscolhidoOrDefault: {
			get() {
				return this.estratoNivelPovoamentoEscolhido || this.estratosDaFazenda[0]?.idEstratoFlorestal
			},

			set(estratoFlorestalId) {
				this.estratoNivelPovoamentoEscolhido = estratoFlorestalId
			},
		},

		processamentoNivelPovoamentoEscolhidoOrDefault: {
			get() {
				return (
					this.processamentoNivelPovoamentoEscolhido ||
					this.processamentosDoEstratoEscolhido[0]?.idInventarioFlorestal
				)
			},

			set(inventarioFlorestalId) {
				this.processamentoNivelPovoamentoEscolhido = inventarioFlorestalId
			},
		},

		valoresVariavelBiometrica() {
			return this.dadosNivelPovoamentoProcessamentoEscolhido
				? this.dadosNivelPovoamentoProcessamentoEscolhido[this.variavelBiometricaMapa].talhoes
				: []
		},

		minimoVariavelBiometrica() {
			return this.valoresVariavelBiometrica.length
				? this.valoresVariavelBiometrica.map((m) => m.media).reduce((a, b) => Math.min(a, b))
				: 0
		},

		maximoVariavelBiometrica() {
			return this.valoresVariavelBiometrica.length
				? this.valoresVariavelBiometrica.map((m) => m.media).reduce((a, b) => Math.max(a, b))
				: 0
		},
		dropdownVariaveisBiometricas() {
			return variaveisBiometricas
		},
		dadoSortimentoFlatMap() {
			return this.dadosSortimento.length
				? orderBy(
						this.dadosSortimento.flatMap((sortimento) => {
							return sortimento.plantiosSortimento.map((plantio) => {
								return { ...plantio, produto: sortimento.produto }
							})
						}),
						'produto',
					)
				: []
		},
		dadosSortimentoAgrupadosPorProduto() {
			return groupBy(this.dadoSortimentoFlatMap, 'plantio')
		},
		sortimento() {
			return Object.keys(this.dadosSortimentoAgrupadosPorProduto).map((plantio) => {
				return {
					name: plantio,
					data: this.dadosSortimentoAgrupadosPorProduto[plantio].map(
						(sortimento) => sortimento[this.quantidadeVolume],
					),
				}
			})
		},
		categorias() {
			return [...new Set(this.dadoSortimentoFlatMap.map((dado) => dado.produto))]
		},

		dadosArvoresUteisPorPlantio() {
			if (
				this.dataGraficoArvoresUteisPorPlantio == null ||
				this.dataGraficoArvoresUteisPorPlantio.length === 0
			) {
				return false
			} else {
				return true
			}
		},
		dadosNivelPovoamentoEstrato() {
			if (!this.nivelPovoamentoEstrato.length) return []

			return this.nivelPovoamentoEstrato
				.filter((estrato) => this.estratosEscolhidos.includes(estrato.id))
				.map((estrato) => {
					return {
						color: estrato.color,
						name: estrato.descricao,
						data: estrato.inventarios.map((inventario) => {
							return [
								new Date(inventario.dataFinalOS).getTime(),
								inventario[this.variavelSelecionada],
							]
						}),
					}
				})
		},
		dadosNivelPovoamentoTalhao() {
			if (!this.nivelPovoamentoTalhao.length) return []

			return this.nivelPovoamentoTalhao
				.filter((estrato) => this.talhoesEscolhidos.includes(estrato.id))
				.map((estrato) => {
					return {
						color: estrato.color,
						name: estrato.descricao,
						data: estrato.inventarios.map((inventario) => {
							return [
								new Date(inventario.dataDeMedicao).getTime(),
								inventario[this.variavelSelecionada],
							]
						}),
					}
				})
		},
		dadosNivelPovoamentoArvore() {
			if (!this.nivelPovoamentoArvore.length) return []

			return this.nivelPovoamentoArvore
				.filter((estrato) => this.arvoresEscolhidas.includes(estrato.id))
				.map((estrato) => {
					return {
						color: estrato.color,
						name: estrato.descricao,
						data: estrato.inventarioArvore.map((inventario) => {
							return [
								new Date(inventario.dataDeMedicao).getTime(),
								inventario[this.variavelSelecionada],
							]
						}),
					}
				})

			// return this.nivelPovoamentoArvore.length ? this.nivelPovoamentoArvore.map(estrato => {
			//   return {
			//     name: estrato.descricao,
			//     data: estrato.inventarioArvore.map(inventario => {
			//       return [new Date(inventario.dataDeMedicao).getTime(), inventario[this.variavelSelecionada || 'volumeTotalComCasca']]
			//     })
			//   }
			// }) : []
		},
		tableConfiguration() {
			return {
				statusTable: this.$t('loading') + '...',
				prefix: 'ES',
				subtitleCardPropertie: 'espe_ds_nome',
				titleCardPropertie: 'espe_cd_codigo',
			}
		},
		tableHeaders() {
			return [
				{ key: 'codigo', value: this.$t('variable'), isActive: true },
				{
					key: 'area',
					value: this.$t('area') + ' (ha)',
					isActive: true,
				},
				{
					key: 'media',
					value: this.$t('mean'),
					isActive: true,
				},
				{
					key: 'li',
					value: this.$t('IC.LI'),
					isActive: true,
				},
				{
					key: 'ls',
					value: this.$t('IC.LS'),
					isActive: true,
				},
				{
					key: 'un',
					value: this.$t('IC.UN'),
					isActive: true,
				},
				{
					key: 'proporcao',
					value: this.$t('IC.P') + ' (%)',
					isActive: true,
				},
				{
					key: 'ns',
					value: this.$t('IC.NS') + ' (%)',
					isActive: true,
				},
			]
		},
		variavelRelacionadaNivelPovoamento() {
			const dadosVariavel = this.dadosNivelPovoamentoProcessamentoEscolhido
				? JSON.parse(
						JSON.stringify(
							this.dadosNivelPovoamentoProcessamentoEscolhido[this.variavelSelecionada],
						),
					)
				: undefined
			if (dadosVariavel) {
				dadosVariavel.talhoes.unshift({
					codigo: dadosVariavel.name,
					area: dadosVariavel.estrato.area,
					media: dadosVariavel.estrato.media,
					li: dadosVariavel.estrato.li,
					ls: dadosVariavel.estrato.ls,
					un: dadosVariavel.estrato.un,
					proporcao: dadosVariavel.estrato.proporcao,
					ns: dadosVariavel.estrato.ns,
				})
				return dadosVariavel.talhoes
			}

			return []
		},
		variavelNivelPovoamento() {
			const dadosVariavel = this.dadosNivelPovoamentoProcessamentoEscolhido
				? JSON.parse(
						JSON.stringify(
							this.dadosNivelPovoamentoProcessamentoEscolhido[this.variavelSelecionada],
						),
					)
				: undefined
			if (dadosVariavel) {
				dadosVariavel.talhoes.unshift({
					codigo: dadosVariavel.name,
					area: dadosVariavel.estrato.area,
					media: dadosVariavel.estrato.media,
					li: dadosVariavel.estrato.li,
					ls: dadosVariavel.estrato.ls,
					un: dadosVariavel.estrato.un,
					proporcao: dadosVariavel.estrato.proporcao,
					ns: dadosVariavel.estrato.ns,
				})
				return dadosVariavel.talhoes
			}
			return []
		},
		nivelPovoamento() {
			return this.dadosNivelPovoamentoProcessamentoEscolhido
				? Object.keys(this.dadosNivelPovoamentoProcessamentoEscolhido).map((variavel) => {
						const dados = this.dadosNivelPovoamentoProcessamentoEscolhido[variavel]
						dados.estrato.codigo = dados.name
						return dados.estrato
					})
				: []
		},
		kpisGeral() {
			return !Object.keys(this.kpisData).length && this.isDashboardGeral
				? undefined
				: [
						{
							label: `${this.$t('farms')}`,
							value: converterUnidadeParaLiteral(this.kpisData.quantidadeDeFazendas.toString()),
						},
						{
							label: `${this.$t('totalAreaFarms')} (ha)`,
							value: converterAreaParaLiteral(this.kpisData.areaTotalDasFazendas),
						},
						{
							label: `${this.$t('totalPlantationsArea')} (ha)`,
							value: converterAreaParaLiteral(this.kpisData.areaTotalPlantada),
						},
						{
							label: `${this.$t('totalVolumeWithBark')} (m³)`,
							value:
								this.kpisData.volumeTotalComCasca != null
									? converterVolumeParaLiteral(this.kpisData.volumeTotalComCasca)
									: '-',
						},
						{
							label: `${this.$t('totalVolumeWithOutBark')} (m³)`,
							value:
								this.kpisData.volumeTotalSemCasca != null
									? converterVolumeParaLiteral(this.kpisData.volumeTotalSemCasca)
									: '-',
						},
						{
							label: ` ${this.$t('ima2')}`,
							value:
								this.kpisData.incrementoMedioAnual != null
									? converterIMAParaLiteral(this.kpisData.incrementoMedioAnual)
									: '-',
						},
					]
		},
		kpisFazenda() {
			return !Object.keys(this.kpisData).length && !this.isDashboardGeral
				? undefined
				: [
						{
							label: `${this.kpisData.areaDaFazenda ? this.$t('totalAreaFarm') : 'área total dos estratos'} (ha)`,
							value: converterAreaParaLiteral(
								this.kpisData.areaDaFazenda
									? this.kpisData.areaDaFazenda
									: this.kpisData.areaDoEstrato,
							),
						},
						{
							label: `${this.$t('agePlantation')}`,
							value: `${this.kpisData.faixaDeIdadeDosPlantios} ${this.$t('years')}`,
						},
						{
							label: `${this.$t('totalVolumeWithBark')} (m³)`,
							value:
								this.kpisData.volumeTotalComCasca != 0
									? converterVolumeParaLiteral(this.kpisData.volumeTotalComCasca)
									: '-',
						},
						{
							label: `${this.$t('totalVolumeWithOutBark')} (m³)`,
							value:
								this.kpisData.volumeTotalSemCasca != 0
									? converterVolumeParaLiteral(this.kpisData.volumeTotalSemCasca)
									: '-',
						},
						// {
						//   label: ` ${this.$t("aai")} (m³/ha/ano)`,
						//   value: this.kpisData.incrementoMedioAnual ?
						//       this.kpisData.incrementoMedioAnual.toFixed(2).replace(".", ",") :
						//       "-",
						// },
						{
							label: `${this.$t('mortalityRate')}`,
							value:
								this.kpisData.taxaDeMortalidade != 0
									? `${this.kpisData.taxaDeMortalidade.toFixed(2).replace('.', ',')} % `
									: '-',
						},
					]
		},
		kpis() {
			return this.isDashboardGeral ? this.kpisGeral : this.kpisFazenda
		},
		ultimoInventario() {
			return this.$store.state.moduleDashboardCardInfo.cardInfo.length
				? this.$store.state.moduleDashboardCardInfo.cardInfo[0].inventarioEstratoFlorestalId
				: undefined
		},
		/**
		 * Propriedade computada que serve para identificador para mostrar
		 * cards que estejam no Dashboard Geral
		 */
		isDashboardGeral() {
			return this.fazendaId === ''
		},
		/**
		 * Recupera o titulo do dashboard
		 * Visão geral para todas as fazendas
		 */
		tituloDashboard() {
			return this.nomeDaFazendaAtual === '' ? this.$t('overview') : this.nomeDaFazendaAtual
		},
		/**
		 * Retorna a label contendo a data do ultimo processamento
		 */
		labelUltimoProcessamento() {
			if (!this.dataUltimoProcessamento) return ''
			else if (this.dataUltimoProcessamento.getYear() < 0) return this.$t('notProcessedData')
			return `${this.$t(
				'lastProcessedIn',
			)} ${this.dataUltimoProcessamento.toLocaleDateString()} ${this.$t(
				'at',
			)} ${this.dataUltimoProcessamento.toLocaleTimeString()}`
		},
	},
	components: {
		ProductivityBar,
		CustomLegend,
		SimpleDropdown,
		ButtonDropdown,
		Card,
		CardMap,
		ContentBody,
		ContentHeader,
		GraficoArvoresUteis,
		GraficoArvoresUteisPorPlantio,
		GraficoCategoriaDeArvore,
		GraficoFaixaDeIdade,
		GraficoFazenda,
		GraficoMaterialGenetico,
		KPI,
		Button,
		Loading,
		SubHeader,
		CrudTable,
		GraficoNivelPovoamentoEstrato,
		GraficoSortimento,
	},
	data: () => {
		return {
			dadosNivelPovoamentoProcessamentoEscolhido: {},
			processamentoNivelPovoamentoEscolhido: undefined,
			processamentosDoEstratoEscolhido: [],
			estratoNivelPovoamentoEscolhido: undefined,
			estratosDaFazenda: [],
			variavelBiometricaMapa: 'vtcc',
			arvoresEscolhidas: [],
			estratosEscolhidos: [],
			talhoesEscolhidos: [],
			quantidadeVolumeOptions: [
				{ key: 'quantidade', label: 'Quantidade' },
				{ key: 'volume', label: 'Volume' },
			],
			quantidadeVolume: 'quantidade',
			dadosSortimento: [],
			inventarioFlorestalIdEscolhido: undefined,
			dropdownProcessamentoSortimento: [],
			nivel: 'estrato',
			nivelPovoamentoEstrato: [],
			nivelPovoamentoTalhao: [],
			nivelPovoamentoArvore: [],
			isDropdownOpen: false,
			isDropdownOpenVolumeQuantidade: false,
			relacaoVariavel: {
				arvoresMedVolumeTotalComCasca: 'arvoresMedVolumeTotalSemCasca',
				arvoresMedVolumeTotalSemCasca: 'arvoresMedVolumeTotalComCasca',
				volumeTotalComCasca: 'volumeTotalSemCasca',
				volumeTotalSemCasca: 'volumeTotalComCasca',
				volumeTotalDeMortasComCasca: 'volumeTotalDeMortasSemCasca',
				volumeTotalDeMortasSemCasca: 'volumeTotalDeMortasComCasca',
			},
			variavelSelecionada: 'volumeTotalComCasca',
			dashboardData: {},
			boundsAllPoligonos: {},
			sourceCancelToken: {},
			dataGraficoFazendaCategoriaDeArvores: [],
			dataGraficoArvoresUteis: {},
			dataGraficoArvoresUteisPorPlantio: [],
			dataGraficoMaterialGenetico: [],
			dataGraficoFaixaDeIdade: [],
			dataGraficoFazendas: [],
			dataCardMap: [],
			fazendas: [],
			fazendaId: '',
			kpisData: [],
			// kpis: undefined,
			mapInfoPoligonos: {},
			// Controle de exibicao dos graficos
			exibirKpis: true,
			exibirGraficoMaterialGenetico: true,
			exibirGraficoFaixaDeIdade: true,
			exibirGraficoFazendas: true,
			exibirGraficoProporcaoFustes: true,
			exibirGraficoArvoresUteis: true,
			exibirGraficoArvoresUteisPorPlantio: true,
			exibirGraficoCategoriaDeArvores: true,
			// Nome da Fazenda
			nomeDaFazendaAtual: '',
			// Informa a data do ultimo processamento
			dataUltimoProcessamento: undefined,
		}
	},
	watch: {
		estratoNivelPovoamentoEscolhidoOrDefault: {
			handler(estratoFlorestalId) {
				if (estratoFlorestalId) {
					getProcessamentosByEstratoId(estratoFlorestalId).then((response) => {
						this.processamentosDoEstratoEscolhido = response.data
					})
				}
			},
			immediate: true,
		},

		processamentoNivelPovoamentoEscolhidoOrDefault: {
			handler(inventarioFlorestalId) {
				if (inventarioFlorestalId) {
					getNivelPovoamentoByInventarioFlorestalId(inventarioFlorestalId).then((response) => {
						this.dadosNivelPovoamentoProcessamentoEscolhido = response.data
					})
				}
			},
			immediate: true,
		},
		inventariosIdSelecionados(value) {
			if (value.length) {
				getDashboardDataByInventarioIdList(value).then((response) => {
					this.kpisData = response.data.kpi
					this.dataGraficoMaterialGenetico = response.data.processamentoPorMaterialGenetico
					this.dataGraficoFaixaDeIdade = response.data.processamentoPorFaixaxDeIdade
					this.dataGraficoFazendaCategoriaDeArvores = response.data.proporcaoDeArvores
					this.dataGraficoArvoresUteis = response.data.proporcaoDeArvoresUteis
					this.dataGraficoArvoresUteisPorPlantio = response.data.proporcaoDeArvoresUteisPorPlantio
				})
			}
		},
		inventarioFlorestalIdEscolhido(value) {
			if (value) {
				getSortimentoByInventarioFlorestalId(value).then((response) => {
					this.dadosSortimento = response.data
				})
			} else {
				this.dadosSortimento = []
			}
		},
		dropdownProcessamentoSortimento(value) {
			if (value.length) {
				getSortimentoByInventarioFlorestalId(value[0].inventarioFlorestalId).then((response) => {
					this.dadosSortimento = response.data
				})
			} else {
				this.dadosSortimento = []
			}
		},

		/**
		 * Sempre que o valor de ID da fazenda alterar, deve trazer as informacoes
		 * relacionadas a fazenda selecionada
		 */
		fazendaId: function (fazendaId) {
			this.sourceCancelToken.cancel('Requisicao cancelada')
			this.sourceCancelToken = axios.CancelToken.source()

			this.dataGraficoArvoresUteis = {}
			this.dataGraficoArvoresUteisPorPlantio = []
			this.dataGraficoMaterialGenetico = []
			this.dataGraficoFaixaDeIdade = []
			this.dataGraficoFazendaCategoriaDeArvores = []
			this.dataCardMap = []
			this.dataGraficoFazendas = []
			this.mapInfoPoligonos = {}
			// this.kpis = undefined;

			this.$refs.ref__cardmap.resetToFirstPage()
			this.$refs.ref__cardmap.resetTextFilter()

			if (fazendaId) {
				this.getDashboardFazenda(fazendaId)
			} else {
				this.getDashboardGeral()
			}

			getHistoricoNivelPovoamentoEstrato(fazendaId).then((response) => {
				const ids = response.data.map((estrato) => estrato.id)
				ids.length = 3
				this.estratosEscolhidos = ids

				this.nivelPovoamentoEstrato = response.data.map((estrato) => {
					return { ...estrato, color: chroma.random().hex() }
				})
			})

			getHistoricoNivelPovoamentoTalhao(fazendaId).then((response) => {
				const ids = response.data.map((estrato) => estrato.id)
				ids.length = 3
				this.talhoesEscolhidos = ids

				this.nivelPovoamentoTalhao = response.data.map((estrato) => {
					return { ...estrato, color: chroma.random().hex() }
				})
			})

			getDropdownProcessamentoSortimento(fazendaId).then((response) => {
				if (response.data.length) {
					this.inventarioFlorestalIdEscolhido = response.data[0].inventarioFlorestalId
				}
				this.dropdownProcessamentoSortimento = response.data
			})

			// getHistoricoNivelPovoamentoArvore(fazendaId).then(response => {
			//   const ids = response.data.map(estrato => estrato.id);
			//   ids.length = 3;
			//   this.arvoresEscolhidas = ids;

			//   this.nivelPovoamentoArvore = response.data.map(estrato => { return { ...estrato, color: chroma.random().hex() } })
			// })
		},
	},
	/**
	 * Carrega todos os dados relacionados as fazendas cadastradas
	 */
	created() {
		getAllFazendasComInventarioFlorestalDropdown(this.sourceCancelToken.token).then((response) => {
			this.fazendas = response
		})

		this.sourceCancelToken = axios.CancelToken.source()
		this.getDashboardGeral()

		//   if (dashboardStore.getters.isEmpty) {
		//   dashboardStore.commit('setDashboardData');
		// }
	},
	methods: {
		/**
		 * Seta o id da fazenda
		 */
		setFazendaId(fazendaId) {
			this.fazendaId = fazendaId
		},
		/**
		 * Seta os valores iniciais para cada mapInfo
		 */
		setInitialValueToMapInfo(mapInfos) {
			mapInfos.forEach((mapInfo) => {
				mapInfo.mapInfoPoligono = {}
				mapInfo.isActived = false
			})
			this.dataCardMap = mapInfos
		},

		ExportarCsv() {
			let data = this.nivelPovoamento

			const headers = 'Variável;Área(ha);Média;IC.LI;IC.LS;IC.UN;IC.P(%);IC.NS(%)'
			const rows = data
				.map((row) =>
					Object.values(row)
						.map((value) => {
							if (typeof value === 'number') {
								return String(value).replace('.', ',')
							}
							return value
						})
						.join(';'),
				)
				.join('\n')
			const csv = headers + '\n' + rows
			const csvFile = new Blob(['\ufeff', csv], { type: 'text/csv' })
			const downloadLink = document.createElement('a')
			downloadLink.href = URL.createObjectURL(csvFile)
			downloadLink.download = 'resultado_nivel_povoamento.csv'
			downloadLink.click()
		},

		/**
		 * Junta as informacoes de duas requisicoes diferentes
		 * Requisicao 1 = Informações da fazenda / estrato
		 * Requisicao 2 = Poligonos
		 */
		mergePoligonosToMapInfo() {
			if (this.dataCardMap.length > 0 && this.mapInfoPoligonos.poligonos) {
				const { poligonos, bounds } = this.mapInfoPoligonos

				this.dataCardMap.forEach((mapInfo) => {
					const mapInfoPoligono = poligonos.find(
						(mapInfoPoligono) => mapInfoPoligono.id === mapInfo.id,
					)
					if (mapInfoPoligono) {
						mapInfoPoligono.paths = CoordenatesToGooglePattern(
							mapInfoPoligono.poligono.coordinates,
							mapInfoPoligono.poligono.type,
						)
						mapInfo.mapInfoPoligono = mapInfoPoligono
					}
				})

				const [west, south, east, north] = bounds
				this.boundsAllPoligonos = { east, north, south, west }
			}
		},

		/**
		 * Seta os dados dos cards
		 */
		setDashboardInfoFazenda(dashboardInfoFazendas) {
			this.setInitialValueToMapInfo(dashboardInfoFazendas.cardMapInfos)
			this.mergePoligonosToMapInfo()
		},

		/**
		 * Troca o nome da fazenda atual, atualizando o titulo do dashboard
		 */
		trocarNomeDaFazenda(idDaFazenda) {
			if (idDaFazenda === '') this.nomeDaFazendaAtual = ''
			else {
				this.nomeDaFazendaAtual = this.fazendas.find(
					(fazenda) => fazenda.value === idDaFazenda,
				).label
			}
		},

		/**
		 * Retorna os dados de uma fazenda selecionar no dropdown de fazendas
		 */
		getDashboardFazenda(fazendaId) {
			this.kpisData = {}
			this.$store.dispatch('moduleDashboardCardInfo/apiCardInfoFazenda', fazendaId)

			getEstratosByFazendaId(fazendaId).then((response) => {
				const ordered = orderBy(response.data, (o) => new Date(o.dataDeProcessamento).getTime(), [
					'desc',
				])
				this.estratosDaFazenda = ordered
			})

			this.trocarNomeDaFazenda(fazendaId)

			getDataUltimoProcessamentoByFazendaId(fazendaId, this.sourceCancelToken.token).then(
				(response) => {
					this.dataUltimoProcessamento = new Date(response.data)
				},
			)

			getKpiDashboardFazenda(fazendaId, this.sourceCancelToken.token).then((response) => {
				const result = response.data
				this.kpisData = {
					...result,
					volumeTotalComCasca:
						result.volumeTotalComCasca !== null ? Number(result.volumeTotalComCasca) : 0,
					volumeTotalSemCasca:
						result.volumeTotalSemCasca !== null ? Number(result.volumeTotalSemCasca) : 0,
					incrementoMedioAnual:
						result.incrementoMedioAnual !== null ? Number(result.incrementoMedioAnual) : 0,
					taxaDeMortalidade:
						result.taxaDeMortalidade !== null ? Number(result.taxaDeMortalidade) : 0,
				}
			})

			getInventarioPlantioGroupedByMaterialGeneticoEqualsFazendaId(
				fazendaId,
				this.sourceCancelToken.token,
			).then((response) => {
				this.dataGraficoMaterialGenetico = response.data
				if (this.dataGraficoMaterialGenetico.length === 0) {
					this.exibirGraficoMaterialGenetico = false
				} else {
					this.exibirGraficoMaterialGenetico = true
				}
			})

			getInventarioPlantioGroupedByFaixaDeIdadeEqualsFazendaId(
				fazendaId,
				this.sourceCancelToken.token,
			).then((response) => {
				this.dataGraficoFaixaDeIdade = response.data
				if (this.dataGraficoFaixaDeIdade.length === 0) {
					this.exibirGraficoFaixaDeIdade = false
				} else {
					this.exibirGraficoFaixaDeIdade = true
				}
			})

			getQuantidadeDeArvoresPorCategoriaByFazendaId(fazendaId, this.sourceCancelToken.token).then(
				(response) => {
					this.dataGraficoFazendaCategoriaDeArvores = response.data
					if (this.dataGraficoFazendaCategoriaDeArvores.length === 0) {
						this.exibirGraficoCategoriaDeArvores = false
					} else {
						this.exibirGraficoCategoriaDeArvores = true
					}
				},
			)

			getProporcaoDeArvoresUteisByFazendaId(fazendaId, this.sourceCancelToken.token).then(
				(response) => {
					this.dataGraficoArvoresUteis = response.data
					if (
						this.dataGraficoArvoresUteis.totalDeArvoresUteis == 0 &&
						this.dataGraficoArvoresUteis.totalDeArvoresNaoUteis == 0
					) {
						this.exibirGraficoArvoresUteis = false
					} else {
						this.exibirGraficoArvoresUteis = true
					}
				},
			)

			getProporcaoDeArvoresUteisGroupedByPlantioEqualsFazendaId(
				fazendaId,
				this.sourceCancelToken.token,
			).then((response) => {
				this.dataGraficoArvoresUteisPorPlantio = response.data
				if (
					this.dataGraficoArvoresUteisPorPlantio == null ||
					this.dataGraficoArvoresUteisPorPlantio.length === 0
				) {
					this.exibirGraficoArvoresUteisPorPlantio = false
				} else {
					this.exibirGraficoArvoresUteisPorPlantio = true
				}
			})
		},

		/**
		 * Faz as requisicoes necessarias para recuperar os dados de todas as fazendas
		 */
		getDashboardGeral() {
			this.kpisData = {}
			this.$store.dispatch('moduleDashboardCardInfo/apiCardInfoGeral')

			this.trocarNomeDaFazenda('')

			getDataUltimoProcessamento(this.sourceCancelToken.token).then((response) => {
				this.dataUltimoProcessamento = new Date(response.data)
			})

			getAllInventarioPlantioByMaterialGenetico(this.sourceCancelToken.token).then((response) => {
				this.dataGraficoMaterialGenetico = response.data
				if (this.dataGraficoMaterialGenetico.length === 0) {
					this.exibirGraficoMaterialGenetico = false
				} else {
					this.exibirGraficoMaterialGenetico = true
				}
			})

			getAllInventarioPlantioByFaixaDeIdade(this.sourceCancelToken.token).then((response) => {
				this.dataGraficoFaixaDeIdade = response.data
				if (this.dataGraficoFaixaDeIdade.length === 0) {
					this.exibirGraficoFaixaDeIdade = false
				} else {
					this.exibirGraficoFaixaDeIdade = true
				}
			})

			getKpiDashboardGeral(this.sourceCancelToken.token).then((response) => {
				const result = response.data
				this.kpisData = result
			})
			getInventarioFlorestalComInventarioPlantio(this.sourceCancelToken.token).then((response) => {
				this.dataGraficoFazendas = response.data.filter(
					(item) =>
						item.volumeTotal !== 0 &&
						item.volumeMedio !== null &&
						item.incrementoMedioAnual !== null,
				)
				if (this.dataGraficoFazendas.length === 0) {
					this.exibirGraficoFazendas = false
				} else {
					this.exibirGraficoFazendas = true
				}
			})
		},
	},
}
</script>

<style scped>
.container__dashboard {
	width: 100%;
	height: 100%;
}

.container__dashboard__kpis {
	display: flex;
	justify-content: space-evenly;
	align-items: center;
	flex-wrap: wrap;
}

.container__dashboard__contentbody__card {
	display: flex;
	flex-direction: column;
	margin-top: 1.5rem;
	width: auto;
	max-width: 100%;
	flex: 1;
}

.container__dashboard__contentbody__card > hr {
	margin: 0 1rem;
}

@media screen and (min-width: 992px) {
	.container__dashboard__contentbody__card {
		flex-direction: row;
	}

	.container__dashboard__contentbody__card > hr {
		height: auto;
		margin: 1rem 0;
		display: inline-block;
		width: 0.1px;
	}
}
</style>
